import { Box, Drawer } from '@material-ui/core';
import { Pricing } from '@nemuru-eng/js-api-client';

import { PricingFormWrapper } from '@/components/modules/PricingCreate/components/PricingFormWrapper';
import { PricingTagFormSchema } from '@/components/modules/PricingEditor/schemas/PricingTagFormSchema';
import { TextFormField } from '@/components/shared/components/NewContextForms/TextFormField';
import { Font } from '@/components/shared/components/Font';
import { Text } from '@/components/shared/components/Text';

import { usePricingEditor } from '../hooks/usePricingEditor';

type FormValues = {
  tag: string;
};

interface PricingTagFormProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  pricing: Pricing;
}

export const PricingTagForm = ({ open, setOpen, pricing }: PricingTagFormProps) => {
  const { addTagToPricing } = usePricingEditor(pricing.id);

  const onSubmit = async (data: FormValues) => {
    await addTagToPricing(data.tag);
    setOpen(false);
  };

  return (
    <Drawer anchor={'bottom'} open={open} onClose={() => setOpen(false)}>
      <Box p={6}>
        <Box mb={5}>
          <Font variant={'h3'} color={'title'}>
            <Text tId={'ADD_PRICING_TAG'} />
          </Font>
        </Box>
        <PricingFormWrapper onSubmitForm={onSubmit} formSchema={PricingTagFormSchema}>
          <main style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
            <section
              style={{
                width: '100%',
                display: 'flex',
                gridGap: 24,
                overflowX: 'auto',
                paddingBottom: 32,
              }}
            >
              <TextFormField autoFocus name="tag" label="tag" />
            </section>
          </main>
        </PricingFormWrapper>
      </Box>
    </Drawer>
  );
};
